<template>
  <v-drawer :direction="'right'" :width="'26%'">
    <bar-card :bg="'border10'">
      <div style="height:100%">
        <c-title :item="obj"> </c-title>
        <div style="height:calc(100% - 0.27rem)">
          <div class="content flex-between">
            <div class="row" v-for="(item, index) in list" :key="index">
              <div>
                <img class="pic" :src="baseUrl + item.image_path" />
              </div>
              <div class="numvalue">
                {{ item.name }}:
                <span class="num" :style="setTextColor(item.flag)">
                  {{ item.value }}
                </span>
                {{ item.unit }}
              </div>
            </div>
          </div>
          <div class="bottom">
            <c-title :item="lsObj"> </c-title>
            <div class="card">
              <div class="flex">
                <div
                  class="choseType"
                  :class="active === index ? 'select' : ''"
                  v-for="(item, index) in navList"
                  :key="index"
                  @click="typeSelect(item, index)"
                >
                  {{ item.name }}
                </div>
              </div>

              <div ref="chart" class="chart"></div>
            </div>
          </div>
        </div>
      </div>
    </bar-card>
  </v-drawer>
</template>

<script>
import cTitle from "../components/title";
import { loadChart } from "./chart/chartData";
import { mapGetters } from "vuex";
import { findQxzWlwnNwestData, findWlwWeatherGetLSSJ } from "@/api/zhwl";
export default {
  components: {
    cTitle,
  },
  computed: {
    ...mapGetters(["graphic"]),
  },
  watch: {
    graphic(val) {
      console.log("graphic val>>>>", val);
      this.active = 0;
      this.getData();
      this.loadData();
    },
  },
  data() {
    return {
      obj: {
        src: require("images/zhwl/icon_sssj.png"),
        name: "实时数据",
        hasBtn: true,
        left: true,
      },
      lsObj: {
        src: require("images/zhwl/icon_lssj.png"),
        name: "历史数据",
        hasBtn: false,
        left: true,
      },
      list: [
        // {
        //   src: require("images/zhwl/qw.png"),
        //   name: "温度",
        //   value: "31",
        //   unit: "℃"
        // },
        // {
        //   src: require("images/zhwl/sd.png"),
        //   name: "湿度",
        //   value: "50",
        //   unit: "%"
        // },
        // {
        //   src: require("images/zhwl/fx-right.png"),
        //   name: "风向",
        //   value: "向右"
        // },
        // {
        //   src: require("images/zhwl/fs.png"),
        //   name: "风速",
        //   value: "5",
        //   unit: "m/s"
        // },
        // {
        //   src: require("images/zhwl/qy.png"),
        //   name: "气压",
        //   value: "20",
        //   unit: "mpa"
        // },
        // {
        //   src: require("images/zhwl/yl.png"),
        //   name: "雨量",
        //   value: "200",
        //   unit: "mm"
        // }
      ],
      navList: [
        {
          name: "今天",
          day: 1,
        },
        {
          name: "最近三天",
          day: 3,
        },
        {
          name: "最近一周",
          day: 7,
        },
        {
          name: "近15天",
          day: 15,
        },
        {
          name: "近30天",
          day: 30,
        },
      ],
      active: 0,
      warnList: [],
      animate: false,
      scrollTimer: null,
      baseUrl: "https://iot.joinken.cn/",
    };
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    window.addEventListener("resize", () => {
      this.chart.resize();
    });
    this.loadData();
    this.getData();
  },
  methods: {
    loadData() {
      let startTime = this.$formatDate(
        new Date(new Date() - 1 * 24 * 3600 * 1000),
        "yyyy-MM-dd"
      );

      this.loadDayChart(startTime);
    },
    // loadNowChart() {
    //   getWlwWeatherByToDay({ wlwWeatherId: this.graphic.id }).then(res => {
    //     if (res.code === 200) {
    //       res.data.map(it => {
    //         it.date = this.$formatDate(new Date(it.date), "hh:mm");
    //       });
    //       loadChart(this.chart, res.data);
    //     }
    //   });
    // },
    loadDayChart(startTime) {
      let endTime = this.$formatDate(new Date(), "yyyy-MM-dd");
      findWlwWeatherGetLSSJ({
        wlwWeatherId: this.graphic.id,
        startTime,
        endTime,
        orderTime: "asc",
      }).then((res) => {
        loadChart(this.chart, res.data);
      });
    },
    getData() {
      this.obj.name = this.graphic.name;

      //实时数据获取
      findQxzWlwnNwestData({ deviceId: this.graphic.code }).then((res) => {
        if (res.code === 200) {
          this.list = res.data.data;
        }
      });

      // let startTime = this.$formatDate(
      //   new Date(new Date() - 3600 * 1000),
      //   "yyyy-MM-dd hh:mm:ss"
      // );
      // findWlwWarningByWlwCode({ wlwCode: this.graphic.code, startTime }).then(
      //   res => {
      //     this.warnList = res.data;
      //     this.warnList.map(it => {
      //       it.content =
      //         "当前" +
      //         it.type +
      //         "为" +
      //         it.value +
      //         "，高于阈值" +
      //         it.valve +
      //         "，请注意处理！";
      //     });
      //     this.ScrollUp();
      //   }
      // );
    },
    typeSelect(item, index) {
      this.active = index;
      const day = item.day;
      let startTime = this.$formatDate(
        new Date(new Date() - day * 24 * 3600 * 1000),
        "yyyy-MM-dd"
      );
      this.loadDayChart(startTime);
    },
    setTextColor(val) {
      if (val === "1") {
        return { color: "#f00" };
      }
    },
    ScrollUp() {
      if (this.warnList.length > 1) {
        this.scrollTimer = setInterval(() => {
          this.animate = true;
          setTimeout(() => {
            if (this.$refs.warnList)
              this.$refs.warnList.append(this.$refs.warnList.firstChild);
            this.animate = false;
          }, 1500);
        }, 5000);
      }
    },
    Stop() {
      clearInterval(this.scrollTimer);
    },
    Up() {
      this.ScrollUp();
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.content
  padding 0 10px
  text-align center
  font-size 14px
  flex-wrap wrap


.bottom
  height 67%
  padding-top 10px

  .card
    height calc(100% - 38px)
    padding-top 10px

    .detail
      padding-bottom 10px

      .img
        margin-right 8px

      .name
        padding-bottom 5px
        color #fff

      .date
        color #888

.row
  height 80px
  width 33.2%
  font-size 12px
  display flex
  flex-direction column
  justify-content center
  align-items: center;
  color #fff

  .num
    font-size 0.15rem
    color: #07d1e0;

.pic
  height 0.2rem

.choseType
  margin 0 10px
  font-size 15px
  cursor pointer
  border-bottom 2px solid transparent
  color $textColor

.select
  color $titleColor
  border-bottom 2px solid

.chart
  height calc(100% - 22px)
  width calc(100% - 20px)
  margin 0 10px

.warnList
  color #fff
  font-size 14px
  height 30px
  overflow hidden

  .box
    height calc(100% - 5px)
    padding-top 5px

  span
    padding-left 5px
    overflow hidden
    text-overflow ellipsis
    -webkit-line-clamp 2
    -webkit-box-orient vertical
    display -webkit-box


.anim
  animation animated 1.5s linear forwards

@keyframes animated
  from
    transform translateY(0)

  to
    transform translateY(-100%)
</style>
